import { useConsentSecurities } from './hooks';
import { ConsentSecuritiesTemplate } from 'views/components/templates/establishes';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

export const ConsentSecurities = () => {
  const tempProps = useConsentSecurities();
  const location = useLocation();

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <ConsentSecuritiesTemplate {...tempProps} />
    </form>
  );
};
